// MUI
import { Divider, Skeleton, Stack } from "@mui/material";

const height = 30;
const width = "100%";

export default function SideTreeLoader(props: Readonly<{ length?: number; divider: boolean; hasLabel: boolean }>) {
	const { length = 6, divider = false, hasLabel = false } = props;
	return (
		<Stack px={"15px"}>
			{hasLabel && (
				<Stack mb={"10px"} mx={1}>
					<Skeleton variant="rectangular" width={130} height={11} sx={{ borderRadius: "6px" }} />
				</Stack>
			)}
			<Stack spacing={0.5}>
				{Array.from({ length }).map((_, index) => {
					const key = `tree_loader_${index}`;
					return <Skeleton key={key} variant="rectangular" width={width} height={height} sx={{ borderRadius: "25px" }} />;
				})}
			</Stack>
			{divider && <Divider className="!border-disabled" variant="middle" sx={{ margin: "15px 0 15px 0" }} />}
		</Stack>
	);
}
